<template>
  <div class="panel">
    <img v-if="url" :src="url" alt="" />
    <div class="text">
      <p>{{ text }}</p>
      <span>{{ content }}</span>
    </div>
    <icon class="icon" name="arrow" />
    <!-- <tag v-if="sign != null" plain :color="sign == '1' ? '#3278F3' : '#FF9500'"
      >已签订</tag
    > -->
    <tag v-if="sign != null" plain :color="sign == '2' ? '#3278F3' : '#FF9500'"
      >通过
    </tag>
    <span v-if="time" class="time ">2020/03/06 12:33</span>
  </div>
</template>
<script>
import { Icon } from "vant";
import { Tag } from "vant";
export default {
  name: "ihPanel",
  props: {
    url: {
      type: String,
      default: ""
    },
    text: {
      type: String,
      default: ""
    },
    content: {
      type: String,
      default: ""
    },
    time: {
      type: String,
      default: null
    },
    sign: {
      type: String,
      default: null
    }
  },
  components: {
    Icon,
    Tag
  },
  methods: {}
};
</script>

<style scoped lang="less">
.panel {
  width: 375px;
  height: 54px;
  background: rgba(255, 255, 255, 1);
  padding: 0 25px 0 20px;
  box-sizing: border-box;
  display: flex;
  align-items: center;
  img {
    width: 24px;
    height: 24px;
  }
  p {
    margin: 0;
    font-size: 14px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: rgba(33, 37, 41, 1);
  }
  .text {
    margin-left: 10px;
    position: relative;
    white-space: nowrap;
    span {
      position: absolute;
      font-size: 12px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: rgba(158, 160, 165, 1);
    }
  }
  .icon {
    /*float: right;*/
    position: absolute;
    right: 25px;
    font-size: 12px;
  }
  .van-tag {
    font-size: 11px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: rgba(50, 120, 243, 1);
    position: absolute;
    right: 51px;
  }
  .time {
    font-size: 12px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: rgba(158, 160, 165, 1);
    position: absolute;
    right: 103px;
  }
}
</style>
